import { PageViewProvider, PaginationProvider } from "dash-ui";
import { IdxEmbeddedPortfolioPage } from "./idx-embedded-portfolio-page";

// Container is needed to use PaginationProvider
export const IdxEmbeddedPortfolioContainer = () => (
  <PaginationProvider>
    <PageViewProvider>
      <IdxEmbeddedPortfolioPage />
    </PageViewProvider>
  </PaginationProvider>
);
